import React, {useEffect} from "react";
import {Form, Modal} from "react-bootstrap";
import {useDeleteThemeMutation} from "../../../../../redux/apiSlice";
import {useHistory} from "react-router-dom";
import cogoToast from "cogo-toast";

const DeleteThemeModal = ({showDeleteThemeModal, onHide, details}) => {
    const [
        deleteTheme, // This is the mutation trigger
        {
            isLoading: isDeleting,
            isSuccess: deletedSuccessfully,
        }, // This is the destructured mutation result
    ] = useDeleteThemeMutation()

    const history = useHistory()

    /* Close Modal on Successful Deletion */
    useEffect(() => {
        if (deletedSuccessfully) {
            cogoToast.success("Created 'Delete Theme' Action Successfully")
            onHide()
            history.push(`/themes/view/${details?.userGroup}`)
        }
    }, [deletedSuccessfully]);

    /* Delete Bank */
    const onSubmit = e => {
        e.preventDefault();
        e.stopPropagation();

        deleteTheme({id: details?.id, meta: details, name: details.name})
    }

    return (
        <Modal
            show={showDeleteThemeModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isDeleting ? "static" : true}
            keyboard={!isDeleting}
        >
            <Form
                noValidate
                onSubmit={onSubmit}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Delete Theme
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                    <p>{`Are you sure you want to delete ${details?.name}?`}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        disabled={isDeleting}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isDeleting}
                        className="btn btn-danger btn-elevate px-4 ml-4"
                    >
                        Delete
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default DeleteThemeModal;
